export default "__VITE_PUBLIC_ASSET__c1c39e68__"